import { BaseFetch } from "../main-model"
export default class ReportGraduate extends BaseFetch {
    getReportGraduateBy = (data) =>
    this.authFetch({
      url: "report-grauate/getReportGraduateBy",
      method: "POST",
      body: JSON.stringify(data),
    })

}
